import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      title: 'Crear Presupuesto',
      description: 'Generar nuevo presupuesto para cliente',
      icon: 'FileText',
      variant: 'primary',
      route: '/quotation-management?action=create'
    },
    {
      title: 'Agregar Producto',
      description: 'Añadir producto al catálogo',
      icon: 'Package',
      variant: 'success',
      route: '/product-catalog-management?action=create'
    },
    {
      title: 'Ajustar Stock',
      description: 'Modificar niveles de inventario',
      icon: 'Warehouse',
      variant: 'warning',
      route: '/inventory-control?action=adjust'
    },
    {
      title: 'Nueva Factura',
      description: 'Crear factura independiente',
      icon: 'Receipt',
      variant: 'info',
      route: '/invoice-management?action=create'
    }
  ];

  const handleActionClick = (route) => {
    window.location.href = route;
  };

  return (
    <div className="card p-6">
      <h2 className="text-lg font-heading-semibold text-text-primary mb-6">
        Acciones Rápidas
      </h2>

      <div className="space-y-4">
        {actions.map((action, index) => (
          <div key={index} className="border border-border rounded-lg p-4 hover:border-primary-200 hover:bg-primary-50/30 transition-layout">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-sm font-body-medium text-text-primary mb-1">
                  {action.title}
                </h3>
                <p className="text-xs text-text-secondary mb-3">
                  {action.description}
                </p>
                <Button
                  variant={action.variant}
                  size="sm"
                  iconName={action.icon}
                  iconPosition="left"
                  onClick={() => handleActionClick(action.route)}
                  className="w-full"
                >
                  {action.title}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;